module.exports = __webpack_public_path__ + "static/media/ddk-GINSSEN_01a.2804a535.jpg";